<template>
    <div>
        <layout-card
            :isCustomizable="settings.isCustomizable"
            :type="settings.context"
            :error="error"
            :loading="isLoadingPage || loading"
            class="dashboard__my-activities-card"
            @hide-card="$emit('hide-card', 'my_activities')"
            @edit-card="handleConfigDialog"
            @refresh-card="refreshActivities"
        >
            <template slot="title">{{ name }}</template>
            <template slot="actions">
                <CompassLink
                    :label="$t.__('dashboard.cards.MyActivitiesCard.actions.go_activity_page')"
                    target="_blank"
                    :link="linkActivitiesPage"
                />
            </template>
            <ActivitiesListingTable
                v-if="!isLoadingPage || !loading"
                slot="content"
                :columns="defaultColumns"
            />
        </layout-card>
    </div>
</template>

<script>
import LayoutCard from './LayoutCard.vue';
import CardMixin from './CardMixin.js';
import ActivitiesListingTable from 'vcomponents/activities/listing/ActivitiesListingTable.vue';
import ActivitiesStore from 'stores/activitiesStore.js';
import { createNamespacedHelpers } from 'vuex';
import { debounce } from 'lodash';
const { mapGetters, mapActions } = createNamespacedHelpers('activitiesStores');
import ActivitiesTableColumnsMixins from 'mixins/activities/ActivitiesTableColumnsMixins.js';
const { mapActions: mapPopupPanelActions } = createNamespacedHelpers('popupPanel');

export default {
    components: {
        LayoutCard,
        ActivitiesListingTable,
    },
    mixins: [CardMixin, ActivitiesTableColumnsMixins],
    data() {
        return {
            showConfigModal: false,
        };
    },
    events: {
        'dashboard-activities-card:refreshActivities': 'refreshActivities',
        'dashboard-card-my_activities:fetched': 'initCard',
    },
    computed: {
        ...mapGetters({
            isLoadingPage: 'getLoadingActivitiesPage',
            isLoadingMore: 'getLoadingMore',
            totalActivities: 'getTotalActivitiesInDB',
            activities: 'getActivities',
        }),
        linkActivitiesPage() {
            return this.$router.resolve({
                name: 'activities.crm.listing.all',
            }).href;
        },
    },
    mounted() {
        if (this.cardData) {
            document
                .querySelector('.dashboard__my-activities-card .compass-table')
                .addEventListener('scroll', this.handleScroll);
        }
    },
    async created() {
        if (!this.$store.state.activitiesStores) {
            this.$store.registerModule('activitiesStores', ActivitiesStore);
        }
        await this.initCard();
    },
    beforeDestroy() {
        document
            .querySelector('.dashboard__my-activities-card .compass-table')
            ?.removeEventListener('scroll', this.handleScroll);
        this.$store.unregisterModule('activitiesStores');
    },
    methods: {
        ...mapPopupPanelActions(['open']),
        ...mapActions([
            'initActivityStore',
            'updateFilters',
            'fetchActivitiesCrm',
            'updateLoadingMore',
            'refreshActivities',
            'updateActivityCardName',
        ]),
        async initCard() {
            this.updateActivityCardName(this.type);
            if (this.cardData) {
                await this.updateFilters(this.cardData.filters);
                await this.initActivityStore(true);
            }
        },
        handleScroll: debounce(async function (e) {
            if (this.isLoadingMore) {
                return;
            }
            //end of page
            if (e.target.scrollTop >= e.target.scrollHeight - e.target.offsetHeight) {
                // avoid extra call if after last scroll
                if (this.activities.length < this.totalActivities) {
                    await this.updateLoadingMore(true);
                    await this.fetchActivitiesCrm();
                }
            }
        }, 200),
        handleConfigDialog() {
            this.open({
                key: 'myActivitiesCardConfigDialog',
                props: {
                    cardName: this.type,
                },
            });
        },
    },
};
</script>

<style scoped lang="scss">
.dashboard__my-activities-card::v-deep {
    .card-body {
        margin-bottom: var(--spacing-3);
        margin-top: var(--spacing-3);
        overflow-y: auto;
        padding-bottom: 0;
        padding-top: 0;
        .activities-listing-table__container {
            max-height: 100%;
            .compass-table {
                height: 100%;
            }
        }
    }
}
</style>
